// extracted by mini-css-extract-plugin
module.exports = {"list":"_13a1674","item":"_9b91f92"};